import type { MomentCoupon, MomentListItem } from "../../data/momentOptions";
import ButtonsRow from "./ButtonsRow";
import CouponPreview from "./CouponPreview";

type Props = {
  messageTitle: string;
  listItems: MomentListItem[];
  displayButtons: { id: string; title: string }[];
  shareFlag: boolean;
  couponEnabled: boolean;
  coupon: MomentCoupon;
};

export default function WideListPreview({
  messageTitle, listItems, displayButtons, shareFlag, couponEnabled, coupon,
}: Props) {
  return (
    <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-overflow-hidden tw-text-[13px] tw-leading-relaxed tw-relative">
      {/* 헤더 타이틀 */}
      <div className="tw-px-4 tw-py-3 tw-text-center tw-border-b tw-border-gray-100">
        <span className="tw-text-[13px] tw-font-bold tw-text-gray-900 tw-whitespace-pre-line">
          {messageTitle.trim() || "메인 타이틀"}
        </span>
      </div>
      {/* 리스트1 이미지 + 홍보문구(좌측 하단 오버레이) */}
      <div className="tw-w-full tw-h-40 tw-bg-gray-200 tw-relative tw-overflow-hidden">
        {listItems[0]?.imagePreview && (
          <img
            src={listItems[0].imagePreview}
            alt="미리보기"
            className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
          />
        )}
        <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-t tw-from-black/50 tw-to-transparent" />
        {listItems[0]?.description?.trim() && (
          <div className="tw-absolute tw-bottom-3 tw-left-4 tw-z-10">
            <span className="tw-text-white/90 tw-text-[11px] tw-drop-shadow tw-whitespace-pre-line">
              {listItems[0].description}
            </span>
          </div>
        )}
      </div>

      {/* 리스트 아이템 (리스트2~5) */}
      <div className="tw-divide-y tw-divide-gray-100">
        {(listItems.length > 1 ? listItems.slice(1) : [
          { id: "p1", description: "서브 아이템 1", imagePreview: null, imageName: null, imageFile: null, imageUploadedUrl: "", pcLandingUrl: "", mobileLandingUrl: "" },
          { id: "p2", description: "서브 아이템 2", imagePreview: null, imageName: null, imageFile: null, imageUploadedUrl: "", pcLandingUrl: "", mobileLandingUrl: "" },
        ]).map((item) => (
          <div key={item.id} className="tw-flex tw-items-center tw-p-3 tw-gap-3">
            <div className="tw-w-12 tw-h-12 tw-bg-gray-100 tw-rounded tw-overflow-hidden tw-flex-shrink-0">
              {item.imagePreview && (
                <img src={item.imagePreview} alt="" className="tw-w-full tw-h-full tw-object-cover" />
              )}
            </div>
            <div className="tw-flex-1">
              <span className="tw-text-sm tw-font-medium tw-text-gray-900 tw-block tw-whitespace-pre-line">
                {item.description || "서브 아이템"}
              </span>
            </div>
          </div>
        ))}
      </div>

      {(displayButtons.length > 0 || shareFlag) && (
        <div className="tw-pt-2">
          <ButtonsRow buttons={displayButtons} shareFlag={shareFlag} />
        </div>
      )}
      <CouponPreview couponEnabled={couponEnabled} coupon={coupon} />
    </div>
  );
}
